// React
import React from "react";

// Internal
import {isNullOrUndefined} from "../functions/general";
import { getInputFilledOrEmptyClass } from "./input-shared.jsx";

// CSS
import "./inputs.css";

function InputText(props) {
    const changeHandler = (e) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(e.target.value);
        }
    };

    const blurHandler = (e) => {
        if (typeof props.OnBlur === "function") {
            props.OnBlur(e.target.value);
        }
    };

    const getClassName = () => {
        let className = "eone-ui-text " + getInputFilledOrEmptyClass(props.Value);
        if (props.Code) {
            className = className + " eone-ui-text-code";
        }
        if (props.Class) {
            className = className + " " + props.Class;
        }
        return className;
    };

    const getContainerClassName = () => {
        if (props.ContainerClass) {
            return props.ContainerClass;
        }
        return "eone-ui-input-group";
    };
    
    const getStyle = () => {
        let style = props.Style || {};
        if (props.Height) {
            style.height = props.Height;
        }
        if (props.Grow) {
            style.flexGrow = 1;
        }
        return style;
    };
    
    const getContainerStyle = () => {
        if (props.Grow) {
            return { flexGrow: 1 };
        }
        return null;
    }
    
    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }
    
    return (
        <div className={getContainerClassName()} style={getContainerStyle()}>
            <textarea
                autoFocus={props.AutoFocus}
                id={props.Id}
                className={getClassName()}
                maxLength={props.MaxLength}
                onBlur={blurHandler}
                onChange={changeHandler}
                placeholder={props.Placeholder}
                style={getStyle()}
                title={isNullOrUndefined(props.Title) ? "" : props.Title}
                value={props.Value}
                spellCheck={props.SpellCheck}
                readOnly={props.ReadOnly}
                data-testid={props.DataTestId} />
        </div>
    );
}

export {InputText};